import { put, takeLatest, call } from "redux-saga/effects";
import { drmDailyRecordCancel } from "../../service/drmDailyRecordCancel";
import {
  setCancelDrmDailyRecordSuccess,
  setCancelDrmDailyRecordFailure,
} from "../reducers/drmDailyRecordCancelSlice";

export function* workerCancelDrmDailyRecord(action) {
  const { payload } = action;

  try {
    const response = yield call(drmDailyRecordCancel, [
      payload.userCode,
      payload.details,
      payload.controller,
    ]);

    const successMessage = response?.data?.message || "Daily maintenance record cancelled successfully";
    yield put(setCancelDrmDailyRecordSuccess(successMessage));
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.toString();
    yield put(setCancelDrmDailyRecordFailure(errorMessage));
  }
}

function* drmDailyRecordCancelSaga() {
  yield takeLatest(
    "cancelDrmtDailyRecord/setCancelDrmDailyRecord",
    workerCancelDrmDailyRecord
  );
}

export default drmDailyRecordCancelSaga;
